import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vn9nhwj3zv: FaireBrandEntity = {
  token: "b_vn9nhwj3zv",
  type: "brand",
  name: "Specific Health Solutions",
  avatarUrl:
    "https://cdn.faire.com/fastly/f62a412cd159e1fb416397dc889658200f417ff9bbb6c6442645aa0bdab039f6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/cff7a7b9e73bde79230acdda836bfb8641ecd057b1cc3e9a7e58bf57fe86debf.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f62a412cd159e1fb416397dc889658200f417ff9bbb6c6442645aa0bdab039f6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cff7a7b9e73bde79230acdda836bfb8641ecd057b1cc3e9a7e58bf57fe86debf.png",
  location: "Washington, UT, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "Specific Health Solutions was originally created with a mission to help find all natural solutions to help those people that we love and care about in our lives, but not just those in our lives but for everyone and the people they truly care about in their lives. Specific Health Solutions has a focus on the some of the largest health problems facing individuals in today's world, such as sleep issues, liver stress and slow metabolism, leaky gut syndrome and microbiome balance, aging concerns and staying young, nutrient deficiencies, insulin resistance and glucose imbalance. Our product help you heal from the inside out, join us on improving peoples lives and achieving better health for everyone. We will continue to tackle new health issues and to create new products to naturally help to repair and improve lives.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:36.830Z",
    importedBy: "entity-db-cli",
  },
};
